import * as React from "react";
export const WarningFilled = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={86.971}
      height={78.06}
      viewBox="0 0 86.971 78.06"
      {...props}
    >
      <g transform="translate(-0.093 -26.314)">
        <path
          d="M85.692,89.028,52.438,31.43a10.23,10.23,0,0,0-17.72,0L1.464,89.028a10.23,10.23,0,0,0,8.86,15.346H76.833a10.23,10.23,0,0,0,8.86-15.345Z"
          fill="#f7b500"
        />
        <rect
          width={5.097}
          height={25.486}
          transform="translate(41.029 51.752)"
          fill="#fff"
        />
        <path
          d="M239.4,355.99a3.4,3.4,0,1,0,3.4,3.4,3.4,3.4,0,0,0-3.4-3.4Z"
          transform="translate(-195.82 -273.655)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
